var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content  mailing-address" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "section" }, [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("baseInfo.mailingAddress.office")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: { filterable: "", no: "1" },
                                model: {
                                  value: _vm.searchConditions.officeId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchConditions,
                                      "officeId",
                                      $$v
                                    )
                                  },
                                  expression: "searchConditions.officeId"
                                }
                              },
                              _vm._l(_vm.currentOfficeList, function(office) {
                                return _c("el-option", {
                                  key: office.uuid,
                                  attrs: {
                                    value: office.officeId,
                                    label: office.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("baseInfo.mailingAddress.lobType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  no: "2",
                                  placeholder: _vm.$t(
                                    "common.tips.pleaseChoose"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.searchConditions.lob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchConditions, "lob", $$v)
                                  },
                                  expression: "searchConditions.lob"
                                }
                              },
                              _vm._l(_vm.itemTypeArray, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: { label: item.name, value: item.value }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("baseInfo.mailingAddress.partner")
                            }
                          },
                          [
                            _c("cargo-company-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "3",
                                "method-params": {
                                  customer: true,
                                  active: true,
                                  fba: true
                                },
                                "check-credit": true,
                                "default-value":
                                  _vm.searchConditions.partnerId || "",
                                "data-filter-function": _vm.customerIdFilter
                              },
                              on: {
                                change: function(p) {
                                  _vm.searchConditions.partnerId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "baseInfo.mailingAddress.fbaWarehouseCode"
                              )
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "170px" },
                              attrs: {
                                no: "4",
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_OverseaWarehouse,
                                filterable: "",
                                fields: ["warehouseCode"],
                                "callback-params": { key: "warehouseCode" },
                                "callback-method-type": "value",
                                "tag-value": "warehouseCode",
                                "tag-name": "warehouseCode",
                                "default-value":
                                  _vm.searchConditions.warehouseCode
                              },
                              on: {
                                parentCallBack: function(item) {
                                  return (_vm.searchConditions.warehouseCode =
                                    item.value)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "app-main-inner-row" }, [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "5", type: "primary", size: "mini" },
                      on: { click: _vm.fetchMailingAddressList }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "6", type: "primary" },
                      on: { click: _vm.popMailingAddressAddDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "7", type: "primary" },
                      on: { click: _vm.popMailingAddressEditDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "8", type: "danger" },
                      on: { click: _vm.toBatchDel }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  ),
                  _c("cargo-grid-state-btn", {
                    attrs: {
                      no: "9",
                      "grid-params": _vm.gridParams,
                      "config-module": "100802"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "100802",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  "config-module": "100802",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchMailingAddressList
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm.mailingAddressMaintainDialog.isShow
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.mailingAddressMaintainDialog.isShow,
                "close-on-click-modal": false,
                title: _vm.mailingAddressMaintainDialog.title,
                width: "1100px"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.mailingAddressMaintainDialog,
                    "isShow",
                    $event
                  )
                }
              }
            },
            [
              _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                _c(
                  "div",
                  { staticClass: "app-main-inner-row" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "mailingAddressAddForm",
                        attrs: {
                          model: _vm.mailingAddressForm,
                          inline: true,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "el-form-item-wrapper" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "baseInfo.mailingAddress.lobType"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "170px" },
                                    attrs: {
                                      no: "10",
                                      placeholder: _vm.$t(
                                        "common.tips.pleaseChoose"
                                      ),
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.mailingAddressForm.lob,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mailingAddressForm,
                                          "lob",
                                          $$v
                                        )
                                      },
                                      expression: "mailingAddressForm.lob"
                                    }
                                  },
                                  _vm._l(_vm.itemTypeArray, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.name,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "baseInfo.mailingAddress.partner"
                                  )
                                }
                              },
                              [
                                _c("cargo-company-select", {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "11",
                                    "method-params": {
                                      customer: true,
                                      active: true,
                                      fba: true
                                    },
                                    "check-credit": true,
                                    "default-value":
                                      _vm.mailingAddressForm.partnerId || "",
                                    "data-filter-function": _vm.customerIdFilter
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.mailingAddressForm.partnerId = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "baseInfo.mailingAddress.fbaWarehouseCode"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "170px" },
                                  attrs: {
                                    no: "12",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_OverseaWarehouse,
                                    filterable: "",
                                    fields: ["warehouseCode"],
                                    "callback-params": { key: "warehouseCode" },
                                    "callback-method-type": "value",
                                    "tag-name": "warehouseCode",
                                    "default-value":
                                      _vm.mailingAddressForm.warehouseCode
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.mailingAddressForm.warehouseCode =
                                        p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "app-main-inner-row" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { height: "400px", "min-height": "400px" },
                        attrs: {
                          inline: true,
                          "label-width": "85px",
                          "label-position": "left"
                        },
                        model: {
                          value: _vm.mailingAddressForm,
                          callback: function($$v) {
                            _vm.mailingAddressForm = $$v
                          },
                          expression: "mailingAddressForm"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "tag-w",
                                    attrs: { size: "medium" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "baseInfo.mailingAddress.shipper"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-form-item-wrapper el-form-item-group"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.formatManifestInfo,
                                            expression: "!formatManifestInfo"
                                          }
                                        ],
                                        style: {
                                          position: "relative",
                                          height: _vm.$selectByLang(
                                            "550px",
                                            "550px",
                                            "550px",
                                            "650px",
                                            "650px",
                                            "650px"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "SeaExport.CompanyName"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: {
                                                no: "13",
                                                placeholder: _vm.$t(
                                                  "SeaExport.CompanyName"
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperEnterpriseName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperEnterpriseName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperEnterpriseName"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.contactName"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "14" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperContactName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperContactName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperContactName"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Tel"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "15" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperContactTel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperContactTel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperContactTel"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_email"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "16" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperContactEmail,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperContactEmail",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperContactEmail"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Fax"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "17" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperFax,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperFax",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperFax"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("SeaExport.ZIP")
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "18" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperZipCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperZipCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperZipCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Country"
                                              )
                                            }
                                          },
                                          [
                                            _c("cargo-advance-select", {
                                              style: _vm.mailingAddressForm
                                                .shipperCountryCode
                                                ? "width: 85%;"
                                                : "width: 100%;",
                                              attrs: {
                                                no: "19",
                                                "select-type":
                                                  _vm.selectTypeNames
                                                    .basic_data_Country,
                                                filterable: "",
                                                "callback-params": {
                                                  key: "shipperCountryCode"
                                                },
                                                "callback-method-type": "value",
                                                "default-value":
                                                  _vm.mailingAddressForm
                                                    .shipperCountryCode
                                              },
                                              on: {
                                                parentCallBack:
                                                  _vm.selectCargoItem
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.province"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "20" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperProvinceCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperProvinceCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperProvinceCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("route.city")
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "21" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperCityCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperCityCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperCityCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr1"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "22" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperAddress1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperAddress1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperAddress1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr2"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "23" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperAddress2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperAddress2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperAddress2"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr3"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "24" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperAddress3,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperAddress3",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperAddress3"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.eoriNo"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "25" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperEoriNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperEoriNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperEoriNo"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.taxNo"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticStyle: { width: "145px" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperVatNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperVatNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperVatNo"
                                              }
                                            }),
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  width: "50px",
                                                  "padding-left": "2px"
                                                },
                                                attrs: {
                                                  placeholder: "",
                                                  no: "26"
                                                },
                                                model: {
                                                  value:
                                                    _vm.mailingAddressForm
                                                      .shipperVatNoType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.mailingAddressForm,
                                                      "shipperVatNoType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "mailingAddressForm.shipperVatNoType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.SystemConstants
                                                  .VAT_NO_TYPES,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.code
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "float-btn-wrapper" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  no: "27",
                                                  type: "info"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.syncFormatInfoToOrder(
                                                      "shipper"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Format"
                                                    ) +
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_ShipperInfo"
                                                      )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "28",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperLine1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperLine1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperLine1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "29",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperLine2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperLine2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperLine2"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "30",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperLine3,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperLine3",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperLine3"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "31",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .shipperLine4,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "shipperLine4",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.shipperLine4"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "tag-w",
                                    attrs: { size: "medium" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "baseInfo.mailingAddress.consignee"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-form-item-wrapper el-form-item-group"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.formatManifestInfo,
                                            expression: "!formatManifestInfo"
                                          }
                                        ],
                                        style: {
                                          position: "relative",
                                          height: _vm.$selectByLang(
                                            "550px",
                                            "550px",
                                            "550px",
                                            "650px",
                                            "650px",
                                            "650px"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "SeaExport.CompanyName"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: {
                                                no: "32",
                                                placeholder: _vm.$t(
                                                  "SeaExport.CompanyName"
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeEnterpriseName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeEnterpriseName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeEnterpriseName"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.contactName"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "33" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeContactName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeContactName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeContactName"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Tel"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "34" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeContactTel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeContactTel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeContactTel"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_email"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "35" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeContactEmail,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeContactEmail",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeContactEmail"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Fax"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "36" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeFax,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeFax",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeFax"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("SeaExport.ZIP")
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "37" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeZipCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeZipCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeZipCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Country"
                                              )
                                            }
                                          },
                                          [
                                            _c("cargo-advance-select", {
                                              style: _vm.mailingAddressForm
                                                .consigneeCountryCode
                                                ? "width: 85%;"
                                                : "width: 100%;",
                                              attrs: {
                                                no: "38",
                                                "select-type":
                                                  _vm.selectTypeNames
                                                    .basic_data_Country,
                                                filterable: "",
                                                "callback-params": {
                                                  key: "consigneeCountryCode"
                                                },
                                                "callback-method-type": "value",
                                                "default-value":
                                                  _vm.mailingAddressForm
                                                    .consigneeCountryCode
                                              },
                                              on: {
                                                parentCallBack:
                                                  _vm.selectCargoItem
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.province"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "39" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeProvinceCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeProvinceCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeProvinceCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("route.city")
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "40" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeCityCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeCityCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeCityCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr1"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "41" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeAddress1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeAddress1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeAddress1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr2"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "42" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeAddress2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeAddress2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeAddress2"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr3"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "43" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeAddress3,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeAddress3",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeAddress3"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.eoriNo"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "44" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeEoriNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeEoriNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeEoriNo"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.taxNo"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticStyle: { width: "145px" },
                                              attrs: { no: "45" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeVatNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeVatNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeVatNo"
                                              }
                                            }),
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  width: "50px",
                                                  "padding-left": "2px"
                                                },
                                                attrs: {
                                                  placeholder: "",
                                                  no: "46"
                                                },
                                                model: {
                                                  value:
                                                    _vm.mailingAddressForm
                                                      .consigneeVatNoType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.mailingAddressForm,
                                                      "consigneeVatNoType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "mailingAddressForm.consigneeVatNoType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.SystemConstants
                                                  .VAT_NO_TYPES,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.code
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "float-btn-wrapper" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  no: "47",
                                                  type: "info"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.syncFormatInfoToOrder(
                                                      "consignee"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Format"
                                                    ) +
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_ConsigneeInfo"
                                                      )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "48",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeLine1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeLine1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeLine1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "49",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeLine2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeLine2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeLine2"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "50",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeLine3,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeLine3",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeLine3"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "51",
                                                readonly: _vm.readonly
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .consigneeLine4,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "consigneeLine4",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.consigneeLine4"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "tag-w",
                                    attrs: { size: "medium" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("baseInfo.mailingAddress.notify")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-form-item-wrapper el-form-item-group"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.formatManifestInfo,
                                            expression: "!formatManifestInfo"
                                          }
                                        ],
                                        style: {
                                          position: "relative",
                                          height: _vm.$selectByLang(
                                            "550px",
                                            "550px",
                                            "550px",
                                            "650px",
                                            "650px",
                                            "650px"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "SeaExport.CompanyName"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: {
                                                no: "52",
                                                placeholder: _vm.$t(
                                                  "SeaExport.CompanyName"
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyEnterpriseName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyEnterpriseName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyEnterpriseName"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.contactName"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "53" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyContactName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyContactName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyContactName"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Tel"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "54" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyContactTel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyContactTel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyContactTel"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_email"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "55" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyContactEmail,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyContactEmail",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyContactEmail"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Fax"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "56" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyFax,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyFax",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyFax"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("SeaExport.ZIP")
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "57" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyZipCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyZipCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyZipCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Country"
                                              )
                                            }
                                          },
                                          [
                                            _c("cargo-advance-select", {
                                              style: _vm.mailingAddressForm
                                                .notifyCountryCode
                                                ? "width: 85%;"
                                                : "width: 100%;",
                                              attrs: {
                                                no: "58",
                                                "select-type":
                                                  _vm.selectTypeNames
                                                    .basic_data_Country,
                                                filterable: "",
                                                "callback-params": {
                                                  key: "notifyCountryCode"
                                                },
                                                "callback-method-type": "value",
                                                "default-value":
                                                  _vm.mailingAddressForm
                                                    .notifyCountryCode
                                              },
                                              on: {
                                                parentCallBack:
                                                  _vm.selectCargoItem
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.province"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "59" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyProvinceCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyProvinceCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyProvinceCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t("route.city")
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "60" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyCityCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyCityCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyCityCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr1"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "61" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyAddress1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyAddress1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyAddress1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr2"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "62" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyAddress2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyAddress2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyAddress2"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.addr3"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "63" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyAddress3,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyAddress3",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyAddress3"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.eoriNo"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              attrs: { no: "64" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyEoriNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyEoriNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyEoriNo"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "baseInfo.mailingAddress.taxNo"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticStyle: { width: "145px" },
                                              attrs: { no: "65" },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyVatNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyVatNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyVatNo"
                                              }
                                            }),
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  width: "50px",
                                                  "padding-left": "2px"
                                                },
                                                attrs: {
                                                  no: "66",
                                                  placeholder: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.mailingAddressForm
                                                      .notifyVatNoType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.mailingAddressForm,
                                                      "notifyVatNoType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "mailingAddressForm.notifyVatNoType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.SystemConstants
                                                  .VAT_NO_TYPES,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.code
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "float-btn-wrapper" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  no: "67",
                                                  type: "info"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.syncFormatInfoToOrder(
                                                      "notify"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Format"
                                                    ) +
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_NotifyInfo"
                                                      )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "68",
                                                readonly: _vm.readonly
                                              },
                                              nativeOn: {
                                                dblclick: function($event) {
                                                  return _vm.popRowDataEditor(
                                                    "notify"
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyLine1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyLine1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyLine1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "69",
                                                readonly: _vm.readonly
                                              },
                                              nativeOn: {
                                                dblclick: function($event) {
                                                  return _vm.popRowDataEditor(
                                                    "notify"
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyLine2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyLine2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyLine2"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "70",
                                                readonly: _vm.readonly
                                              },
                                              nativeOn: {
                                                dblclick: function($event) {
                                                  return _vm.popRowDataEditor(
                                                    "notify"
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyLine3,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyLine3",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyLine3"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "uppercase",
                                                  rawName: "v-uppercase"
                                                }
                                              ],
                                              staticClass: "input-w",
                                              attrs: {
                                                no: "71",
                                                readonly: _vm.readonly
                                              },
                                              nativeOn: {
                                                dblclick: function($event) {
                                                  return _vm.popRowDataEditor(
                                                    "notify"
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.mailingAddressForm
                                                    .notifyLine4,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.mailingAddressForm,
                                                    "notifyLine4",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mailingAddressForm.notifyLine4"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "72", type: "primary" },
                      on: { click: _vm.submitMailingAddress }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "73" },
                      on: { click: _vm.cancelSaveOrEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }